import React, { useState } from 'react';

import { useParams, useNavigate } from 'react-router-dom';
import { Grid, Container, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import loginStyles from 'Styles/loginStyles';
import useEventListener from 'Hooks/useEventListener';
import { confirmUser } from 'Data/api';
import { ReactComponent as LogoIcon } from "assets/logo.svg";
// import { getWhitelabel } from 'lib/storage';

const ConfirmUser = () => {
	const classes = loginStyles();
	const navigate = useNavigate();
	const { token } = useParams();
	const { t } = useTranslation();

	const [password, setPassword] = useState('');
	const [passwordConfirm, setPasswordConfirm] = useState('');
	const [confirmingUser, setConfirmingUser] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');

	const handleConfirmUser = async () => {
		let success = true;

		setErrorMsg('');

		if (password === '' && passwordConfirm === '') {
			success = false;
			setErrorMsg(t('forgotPassword.noEmptyPassword'));
		} else if (password.length < 8) {
			success = false;
			setErrorMsg(t('forgotPassword.passwordLength'));
		} else if (password !== passwordConfirm) {
			success = false;
			setErrorMsg(t('forgotPassword.passwordNoMatch'));
		}

		if (success) {
			setConfirmingUser(true);

			const result = await confirmUser({ token: token, newPassword: password });

			setConfirmingUser(false);

			if (!result || result !== 200) {
				setErrorMsg(t('forgotPassword.userDontExist'));
			} else {
				navigate('/login');
			}
		}
	}

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			handleConfirmUser();
		}
	};

	useEventListener('keypress', handleKeyPress);

	return (
		<>
		<Container component="main" maxWidth="sm">
			<div className={classes.logoWrapper}>
				<LogoIcon className={classes.logoHeader} />
			</div>

			{/* <Paper elevation={3} className={classes.loginPaper}> */}

			<Typography className={classes.loginHeader}>{t('forgotPassword.confirm')}</Typography>

								{errorMsg ? <div className={classes.errorMsg}>{errorMsg}</div> : ""}

					{!confirmingUser ?
						<>
						<Grid container>
							<Grid item xs={12}>
								<TextField
									id="password"
									type="password"
									autoFocus
									onChange={(event) => setPassword(event.target.value)}
									className={classes.textField}
									label={t('login.password')}
									variant="outlined"
									error={errorMsg.length}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									id="passwordConfirm"
									type="password"
									onChange={(event) => setPasswordConfirm(event.target.value)}
									className={classes.textField}
									label={t('forgotPassword.confirmPassword')}
									variant="outlined"
									error={errorMsg.length}
								/>
							</Grid>
						
							<Grid item xs={12}>
								<div className={classes.buttonWrapper}>
									<Button
										variant="contained"
										color="primary"
										className={classes.loginButton}
										disabled={confirmingUser}
										onClick={() => handleConfirmUser()}>
										{t('forgotPassword.confirm')}
									</Button>
								</div>
							</Grid>
						</Grid>
						</>
						: <CircularProgress size={24} className={classes.buttonProgress} />}
		</Container>
		</>
	)
}

export default ConfirmUser;
